module.exports = __webpack_public_path__ + "img/firmBanner_bg.e4159ef.png";